import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";

export default function AdminRedirectsPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ from_path: "", to_path: "", status_code: 301 });

  const load = async () => { const { data } = await api.get("/admin/redirects"); setItems(data || []); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.from_path || !form.to_path) return;
    await api.post("/admin/redirects", form);
    setForm({ from_path: "", to_path: "", status_code: 301 });
    load();
  };
  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/admin/redirects/${id}`); load(); };

  return (
    <div data-testid="admin-redirects">
      <h1 className="font-serif text-4xl text-cc-text mb-2">Yönlendirmeler</h1>
      <p className="text-sm text-cc-muted mb-8">301 / 302 redirect yöneticisi</p>

      <form onSubmit={add} className="bg-white border border-admin-border p-5 mb-6 grid md:grid-cols-4 gap-3 items-end">
        <label className="text-xs text-cc-muted">From <input value={form.from_path} onChange={(e) => setForm({ ...form, from_path: e.target.value })} className="cc-input" placeholder="/eski/url" data-testid="red-from" /></label>
        <label className="text-xs text-cc-muted">To <input value={form.to_path} onChange={(e) => setForm({ ...form, to_path: e.target.value })} className="cc-input" placeholder="/yeni/url" data-testid="red-to" /></label>
        <label className="text-xs text-cc-muted">Status
          <select value={form.status_code} onChange={(e) => setForm({ ...form, status_code: parseInt(e.target.value) })} className="cc-input">
            <option value={301}>301 (kalıcı)</option><option value={302}>302 (geçici)</option>
          </select>
        </label>
        <button className="cc-btn text-[10px] py-2"><Plus size={14} /> Ekle</button>
      </form>

      <div className="bg-white border border-admin-border">
        <table className="w-full text-sm">
          <thead className="bg-admin-bg/60 text-left">
            <tr>
              <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">From</th>
              <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">To</th>
              <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Status</th>
              <th></th></tr>
          </thead>
          <tbody>
            {items.map((r) => (
              <tr key={r.id} className="border-t border-admin-border">
                <td className="px-4 py-3 font-mono text-xs">{r.from_path}</td>
                <td className="px-4 py-3 font-mono text-xs text-cc-sepia">{r.to_path}</td>
                <td className="px-4 py-3 text-cc-muted">{r.status_code}</td>
                <td className="px-4 py-3 text-right"><button onClick={() => del(r.id)} className="text-cc-muted hover:text-red-600"><Trash2 size={14} /></button></td>
              </tr>
            ))}
            {items.length === 0 && <tr><td colSpan="4" className="px-4 py-6 text-cc-muted">Yönlendirme yok.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
